import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Icon } from '@resy/ui-kitchen';

import './GlobalMessage.scss';
import IconClose from '../../svg/dynamic/ic_close_20x20.svg';
import { getTranslation } from '../../../../../ui-kitchen/src/providers/TranslationProvider';

class GlobalMessage extends React.Component {
  static propTypes = {

    messages: PropTypes.arrayOf(
      PropTypes.string
    ),
    position: PropTypes.shape({
      bottom: PropTypes.string,
      left: PropTypes.string,
      right: PropTypes.string,
      top: PropTypes.string,
    }),
    ariaLabel: PropTypes.string,
  }

  static defaultProps = {
    messages: undefined,
    position: {
      left: '0',
      top: '0',
    },
    ariaLabel: getTranslation({ translationKey: 'close', fallback: 'Close' }),
  };

  state = {
    open: true,
  }

  onClose = () => {
    this.setState({ open: false });
  }

  render() {
    const { messages, position, ariaLabel } = this.props;
    const { open } = this.state;

    if (!messages) {
      return null;
    }

    return (
      <div
        aria-live="assertive"
        className={cx('GlobalMessage', { GlobalMessage__closed: !open })}
        style={{ ...position }}
      >
        <Button
          variant="no-style"
          onClick={this.onClose}
          data-test-id="global_message-button-close"
          aria-label={ariaLabel}
        >
          <Icon component={IconClose} name="close" />
        </Button>
        <ul>
          {messages.map((msg) => <li key={msg.substring(0, 9)}>{msg}</li>)}
        </ul>
      </div>
    );
  }
}

export default GlobalMessage;
